import { defineStore } from "pinia";
import { ref } from "vue";
import { API } from "@/queries/index";
import { AxiosError } from "axios";
import { APIResponse, APIResponseError } from "@/types/api";
import { handleResponse, handleResponseError } from "@/utils/api";
import { DashboardDataResponse, DashboardItemByCategory, DashboardItemByGroupCategory, DashboardMostItemRequested } from "@/types/interface/dashboard";

export const useDashboardStore = defineStore("dashboardStore", () => {
  const generalData = ref<DashboardDataResponse>();
  const mostItemReq = ref<DashboardMostItemRequested>();
  const itemCategory = ref<DashboardItemByCategory[]>([]);
  const itemGroupCategory = ref<DashboardItemByGroupCategory[]>([]);

  function initData(data: any) {
    generalData.value = data?.data;
  }

  function initMostItem(data: any) {
    mostItemReq.value = data?.data;
  }

  function initItemByCategory(data: any) {
    itemCategory.value = data?.data;
  }

  function initItemByGroupCategory(data: any) {
    itemGroupCategory.value = data?.data;
  }


  async function dispatchGeneral() : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.dashboardGeneral.dashboardGeneral();
      if (status === 200 ) {
        initData(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchItemByCategory() : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.dashboardGeneral.dashboardGetItemByCategory();
      if (status === 200 ) {
        initItemByCategory(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchItemByGroupCategory(query: string) : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.dashboardGeneral.dashboardGetItemByGroupCategory(query);
      if (status === 200 ) {
        initItemByGroupCategory(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchRequisitionOverview(query: string) : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.dashboardGeneral.dashboardRequisitionOverview(query);
      if (status === 200 ) {
        initData(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchMostItemRequested(query: string) : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.dashboardGeneral.dashboardMostItemRequested(query);
      if (status === 200 ) {
        initMostItem(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  return {
    generalData,
    mostItemReq,
    itemCategory,
    itemGroupCategory,
    dispatchGeneral,
    dispatchItemByCategory,
    dispatchItemByGroupCategory,
    dispatchRequisitionOverview,
    dispatchMostItemRequested
  };
});